<template lang="pug">
  div
    v-card.mb-3
      v-card-title.grey.lighten-4
        .title {{extra.name}}
      div
        template(v-for="content in contents")
          v-divider
          .px-3.py-2.d-flex.align-center
            .pr-2(v-if="content.image")
              img.content-img(:src="content.image")
            router-link(:to="contentUrl(content)") {{content.title}}

</template>

<style lang="stylus" scoped>
.content-img
  width 60px
  height auto

</style>


<script>
import ContentUrl from '../../mixins/content-url'
export default {
  props: ['extra'],
  mixins: [ContentUrl],
  computed: {
    contents() {
      if (this.extra && this.extra.content) {
        return JSON.parse(this.extra.content)
      } else {
        return [] 
      }
    }
  }
}
</script>
